import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { resultCountStyles } from "@dana/Overrides/Widgets/OrderHistory/OrderHistoryResultCount";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

resultCountStyles.countsGrid = mergeToNew(resultCountStyles.countsGrid, {
    gap: 10,
});

resultCountStyles.countsGridItem = mergeToNew(resultCountStyles.countsGridItem, {
    width: [12, 12, 4, 4, 4],
});

resultCountStyles.countsGridItemInner = mergeToNew(resultCountStyles.countsGridItemInner, {
    css: css`
        background: white;
        width: 100%;
        padding: 24px;
        display: flex;
        justify-content: space-between;
        border: 1px solid ${themeBackgrounds.lightGray};

        &.order-details-box {
            align-items: center;
            ${IconWrapper} {
                flex: 1;
                flex-shrink: 0;
            }

            .order-details-box-content {
                flex: 2;
                text-align: right;
            }
        }
    `,
});

resultCountStyles.countItemContent = mergeToNew(resultCountStyles.countItemContent, {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        [class*="StyledTypography"] {
            text-decoration: none;
        }
    `,
});

resultCountStyles.orderType = mergeToNew(resultCountStyles.orderType, {
    color: themeBackgrounds.darkGray,
    css: css`
        margin-bottom: auto;
    `,
});

resultCountStyles.orderCountText = mergeToNew(resultCountStyles.orderCountText, {
    size: fontSizes.xLarge,
    lineHeight: lineHeights.xLarge,
    weight: fontWeights.bold,
});
